// @flow

import React, { type Node } from 'react';
import { useIncomingPayment, getCountry, getPaymentTypeCode } from '@tectonics/prs/incoming-payment';

export function InfoMessage(): Node {
  const incomingPayment = useIncomingPayment();

  switch (getPaymentTypeCode(incomingPayment)){
    case 'mpconnect':
      return ( <MpConnectMessage /> );
    default:
      return null;
  }
}

function MpConnectMessage(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'ar':
    case 'cl':
    case 'uy':
      return (
        <span>
          Serás re-direccionado al sitio de Mercado pago
        </span>
      );
    case 'br':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'bo':
      return '';
    default:
      throw new Error(`MpConnect redirect message for: "${country}" not found`);
  }
}
